//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  openModal(modal:string|{}) {
    Dispatcher.dispatchAction(Constants.OPEN_MODAL, modal);
  },

  closeModal(modal:string) {
    Dispatcher.dispatchAction(Constants.CLOSE_MODAL, modal);
  },
};
